import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {firstValueFrom, Observable, of} from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UserResourceService } from 'src/libs/api-client';
import { GlobalState } from 'src/app/global.state';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private afAuth: AngularFireAuth, private router: Router, private userApiService: UserResourceService, private globalState: GlobalState) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>  {

    console.log("AuthGuardService.canActivate()");

    const user = await firstValueFrom(this.afAuth.authState);
    if (!user){

      const currentUrl = state.url; // This contains the full path + query params
      this.router.navigate(['/login'], {
        queryParams: { redirectedFrom: currentUrl }
      });
      return false;
    }
    else if(user){
      const allowedPages = await this.globalState.getAllowedPages();
      return this.logicToGoToPage(allowedPages, state);
    }
    else{
      return false;
    }
  }

  private getFirstPartOfRoute(url: string): string {
    const withoutQuery = url.split('?')[0];
    const withoutFragment = withoutQuery.split('#')[0];
    const parts = withoutFragment.split('/');
    return `/${parts[1]}`;
  }

  private logicToGoToPage(allowedPages: string[], state: RouterStateSnapshot) : boolean 
    {

      const firstPartOfRoute = this.getFirstPartOfRoute(state.url);

      if(allowedPages.includes(firstPartOfRoute)) {
        return true;
      }

      // will show them which pages they can access if they can't access the page they are trying to go to
      window.location.href = "/accessible-pages?redirectedFrom=" + firstPartOfRoute;
      return false;
    }
}